/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./lang-translate.vue?vue&type=template&id=36920860&scoped=true&"
import script from "./lang-translate.vue?vue&type=script&lang=ts&"
export * from "./lang-translate.vue?vue&type=script&lang=ts&"
import style0 from "./lang-translate.vue?vue&type=style&index=0&id=36920860&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36920860",
  null
  
)

export default component.exports